import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';

const styles = css `
.privacyPolicy_body {
  font-weight: 300;
  font-size: 18px;
  line-height: 35px;
  color: #212529;
}
.privacyPolicy_title {
  text-align: center;
  font-weight: 300;
  color: #000000;
  line-height: 54px;
  font-size: 30px;
}
`;


function PrivacyPolicy({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'primary_image')}
      />
      <div className={styles}>
        <div className="container">
          <h2 className="my-5 privacyPolicy_title">{get(page, 'content[0].title')}</h2>
          <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'content[0].body'))} className="col-12 my-5 privacyPolicy_body" />
        </div>
      </div>
    </PageWrapper>
  );
}

PrivacyPolicy.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'privacy_policy',
  },
  {
    ifMissing404: true,
  },
)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/index.js